import { render, staticRenderFns } from "./PolizasRHMovimientos.vue?vue&type=template&id=a66db424&"
import script from "./PolizasRHMovimientos.vue?vue&type=script&lang=js&"
export * from "./PolizasRHMovimientos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports